var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowNeutral = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "#95aac9",
    className: "bi bi-caret-up-fill",
    viewBox: "10 5 1 21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.972 5.346-5.276 6.03c-.623.71-.117 1.824.828 1.824h10.552a1.1 1.1 0 0 0 .828-1.825L9.628 5.347a1.1 1.1 0 0 0-1.656 0zM9.628 25.454l5.276-6.03c.623-.71.117-1.824-.828-1.824H3.524a1.1 1.1 0 0 0-.828 1.825l5.276 6.028a1.1 1.1 0 0 0 1.656 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowNeutral);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowNeutral.5478d9f0.svg";